/**
 * Use the IntersectionObserver API to animate elements when they are in the viewport.
 */
export const useScrollDirection = ({ offset } = { offset: 100 }) => {
	const scrollDirection = useState('scrollDirections', () => 'none');
	let lastScrollPosition = 0;

	const handleScroll = () => {
		if (import.meta.client) {
			if (window.scrollY < offset) {
				scrollDirection.value = 'none';
			} else if (window.scrollY < lastScrollPosition) {
				scrollDirection.value = 'up';
			} else {
				scrollDirection.value = 'down';
			}

			lastScrollPosition = window.scrollY;
		}
	};

	onBeforeMount(() => {
		window.addEventListener('scroll', handleScroll);
	});

	onBeforeUnmount(() => {
		window.removeEventListener('scroll', handleScroll);
	});

	return scrollDirection;
};
